import { AHIcon, AHText, AHTextFonts } from "arkh";
import React from "react";

export function TodoListItemComments(props: { commentCount: number }) {
  if (props.commentCount === 0) {
    return null;
  }

  return (
    <>
      <AHIcon
        type="message"
        size="xsmall"
        color="text-secondary"
        spaceRight="xsmall"
      />
      <AHText numberOfLines={1} type="body" font={AHTextFonts.MEDIUM}>
        {props.commentCount}
      </AHText>
    </>
  );
}
